import requestSender from "./base/requestSender";

export default function(axiosInstance){
    return {

        search(payload){
            return requestSender('get', 'knowledge-base/search', payload);
        },
        create(payload){
            return requestSender('post', 'knowledge-base/create', payload);
        },
        update(payload){
            return requestSender('post', 'knowledge-base/update', payload);
        },
        setOrder(payload){
            return requestSender('post', 'knowledge-base/set-order', payload);
        },
        delete(payload){
            return requestSender('post', 'knowledge-base/delete', payload);
        },

    }
}